(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_sb-athlete-testimonials-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-athlete-testimonials-slider')) {
    class SbAthleteTestimonialsSlider extends HTMLElement {
      connectedCallback() {
        this.activeIndex = 0;
        this.isUpdating = false;
        this.featured = this.querySelector('[data-athlete-featured]');
        this.mediaEl = this.querySelector('[data-athlete-featured-media]');
        this.starsEl = this.querySelector('[data-athlete-featured-stars]');
        this.quoteEl = this.querySelector('[data-athlete-featured-quote]');
        this.nameEl = this.querySelector('[data-athlete-featured-name]');
        this.roleEl = this.querySelector('[data-athlete-featured-role]');
        this.thumbsEl = this.querySelector('[data-athlete-thumbs]');
        this.onThumbClick = this.onThumbClick.bind(this);
        this.thumbsEl?.addEventListener('click', this.onThumbClick);
        this.hydrateFromItems();
      }

      hydrateFromItems() {
        const items = this.getItems();
        if (!items.length) return;
        this.ensureThumbs(items);
        const hasQuote = Boolean(this.quoteEl?.textContent?.trim());
        if (!hasQuote) {
          this.applyItem(items[0]);
          this.syncThumbs(0);
        }
      }

      ensureThumbs(items) {
        if (items.length < 2) return;
        if (!this.thumbsEl) {
          const content = this.querySelector('[data-athlete-featured-content]');
          if (!content) return;
          this.thumbsEl = document.createElement('div');
          this.thumbsEl.className = 'sb-athlete-testimonials-slider__thumbs';
          this.thumbsEl.setAttribute('role', 'tablist');
          this.thumbsEl.setAttribute('aria-label', 'Athlete testimonials');
          this.thumbsEl.dataset.athleteThumbs = '';
          content.appendChild(this.thumbsEl);
          this.thumbsEl.addEventListener('click', this.onThumbClick);
        }
        if (this.thumbsEl.children.length > 0) return;

        items.forEach((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sb-athlete-testimonials-slider__thumb' + (index === 0 ? ' is-active' : '');
          button.setAttribute('role', 'tab');
          button.dataset.index = String(index);
          button.setAttribute('aria-label', item.dataset.name || `Athlete ${index + 1}`);
          button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
          const thumbSrc = item.dataset.thumbSrc || item.dataset.imageSrc;
          if (thumbSrc) button.style.backgroundImage = `url("${thumbSrc}")`;
          this.thumbsEl.appendChild(button);
        });
      }

      disconnectedCallback() {
        this.thumbsEl?.removeEventListener('click', this.onThumbClick);
      }

      getItems() {
        return [...this.querySelectorAll('[data-athlete-item]')];
      }

      onThumbClick(event) {
        const button = event.target.closest('.sb-athlete-testimonials-slider__thumb');
        if (!button || !this.thumbsEl?.contains(button)) return;
        event.preventDefault();
        const index = Number(button.dataset.index);
        if (Number.isNaN(index) || index === this.activeIndex) return;
        this.showItem(index);
      }

      showItem(index) {
        const item = this.getItems()[index];
        if (!item || !this.featured || this.isUpdating) return;
        this.isUpdating = true;
        this.featured.classList.add('is-fading');

        window.setTimeout(() => {
          this.applyItem(item);
          this.activeIndex = index;
          this.syncThumbs(index);
          this.featured.classList.remove('is-fading');
          this.isUpdating = false;
        }, 180);
      }

      applyItem(item) {
        const quote = item.dataset.quote || '';
        const name = item.dataset.name || '';
        const role = item.dataset.role || '';
        const alt = item.dataset.imageAlt || name;
        const imageSrc = item.dataset.imageSrc || '';
        const imagePosition = item.dataset.imagePosition || 'center top';
        const showStars = item.dataset.showStars === 'true';

        if (this.quoteEl) this.quoteEl.textContent = quote ? `“${quote}”` : '';
        if (this.nameEl) this.nameEl.textContent = name;
        if (this.roleEl) this.roleEl.textContent = role;
        if (this.starsEl) this.starsEl.classList.toggle('is-hidden', !showStars);

        if (this.mediaEl) {
          this.mediaEl.style.setProperty('--image-position', imagePosition);
          const existingImage = this.mediaEl.querySelector('.sb-athlete-testimonials-slider__featured-image');
          const existingPlaceholder = this.mediaEl.querySelector('.sb-athlete-testimonials-slider__featured-placeholder');

          if (imageSrc) {
            if (existingImage) {
              existingImage.src = imageSrc;
              existingImage.alt = alt;
            } else {
              existingPlaceholder?.remove();
              const image = document.createElement('img');
              image.className = 'sb-athlete-testimonials-slider__featured-image';
              image.src = imageSrc;
              image.alt = alt;
              image.loading = 'eager';
              this.mediaEl.appendChild(image);
            }
          } else if (!existingPlaceholder) {
            existingImage?.remove();
            const placeholder = document.createElement('div');
            placeholder.className = 'sb-athlete-testimonials-slider__featured-placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            this.mediaEl.appendChild(placeholder);
          }
        }
      }

      syncThumbs(index) {
        if (!this.thumbsEl) return;
        this.thumbsEl.querySelectorAll('.sb-athlete-testimonials-slider__thumb').forEach((button, buttonIndex) => {
          const isActive = buttonIndex === index;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }
    }

    customElements.define('sb-athlete-testimonials-slider', SbAthleteTestimonialsSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sb-detail-tab"] && !Shopify.designMode) return;
  try {
    (function() {
    function initAudioPlayers() {
        // Initialize audio players
      document.querySelectorAll('._sb-detail-tab__audio-player').forEach(function(player) {
        const btn = player.querySelector('._sb-detail-tab__audio-play-btn');
        const audio = player.querySelector('._sb-detail-tab__audio-element');
        const progressBar = player.querySelector('._sb-detail-tab__audio-progress-bar');
        const timeDisplay = player.querySelector('._sb-detail-tab__audio-time');

        if (!btn || !audio || !progressBar) return;

        // Format time helper function
        function formatTime(seconds) {
          if (!isFinite(seconds) || isNaN(seconds)) return '00:00';
          const mins = Math.floor(seconds / 60);
          const secs = Math.floor(seconds % 60);
          return String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
        }

        // Update time display
        function updateTimeDisplay() {
          if (timeDisplay && audio.duration) {
            const current = formatTime(audio.currentTime || 0);
            const total = formatTime(audio.duration || 0);
            timeDisplay.textContent = current + '/' + total;
          }
        }
        
        // Skip if already initialized
        if (btn.dataset.initialized === 'true') return;
        btn.dataset.initialized = 'true';

        // Play/Pause toggle
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          if (audio.paused) {
            // Pause all other audio players
            document.querySelectorAll('._sb-detail-tab__audio-element').forEach(function(otherAudio) {
              if (otherAudio !== audio && !otherAudio.paused) {
                otherAudio.pause();
                const otherPlayer = otherAudio.closest('._sb-detail-tab__audio-player');
                if (otherPlayer) {
                  const otherBtn = otherPlayer.querySelector('._sb-detail-tab__audio-play-btn');
                  if (otherBtn) otherBtn.classList.remove('is-playing');
                }
              }
            });

            audio.play().then(function() {
              btn.classList.add('is-playing');
            }).catch(function(error) {
              console.error('Audio play failed:', error);
            });
          } else {
            audio.pause();
            btn.classList.remove('is-playing');
          }
        });

        // Update progress bar and time display
        audio.addEventListener('timeupdate', function() {
          if (audio.duration) {
            const progress = (audio.currentTime / audio.duration) * 100;
            progressBar.style.width = progress + '%';
            updateTimeDisplay();
          }
        });

        // Update time display when metadata is loaded
        audio.addEventListener('loadedmetadata', function() {
          updateTimeDisplay();
        });

        // Reset button when audio ends
        audio.addEventListener('ended', function() {
          btn.classList.remove('is-playing');
          progressBar.style.width = '0%';
          updateTimeDisplay();
        });

        // Handle audio loading errors
        audio.addEventListener('error', function(e) {
          console.error('Audio loading error:', e);
        });

        // Click on progress bar to seek
        const progressContainer = player.querySelector('._sb-detail-tab__audio-progress');
        if (progressContainer) {
          progressContainer.addEventListener('click', function(e) {
            if (audio.duration) {
              const rect = progressContainer.getBoundingClientRect();
              const percent = (e.clientX - rect.left) / rect.width;
              audio.currentTime = percent * audio.duration;
            }
          });

          progressContainer.style.cursor = 'pointer';
        }
      });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAudioPlayers);
    } else {
      initAudioPlayers();
    }

    // Also initialize after a short delay to catch dynamically loaded content
    setTimeout(initAudioPlayers, 500);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sb-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-faq')) {
    class SbFaq extends HTMLElement {
      constructor() {
        super();
        this.buttons = [];
        this.contents = [];
      }

      connectedCallback() {
        try {
          this.init();
        } catch (error) {
          console.error('[sb-faq] Initialization error:', error);
        }
      }

      init() {
        this.buttons = Array.from(this.querySelectorAll('.sb-faq--slider ._faq-category__tab-button'));
        this.contents = Array.from(this.querySelectorAll('._sb-faq__content ._faq-category__content'));

        if (this.buttons.length === 0) return;

        this.setupAriaRelationships();
        this.setupEventListeners();
        this.activateTab(this.buttons[0]);
      }

      /**
       * Dynamically assigns unique IDs and ARIA relationships.
       * This is necessary because the _faq-category block is rendered twice
       * (once in slider, once in content area) via captured block_contents.
       * Static IDs would cause duplicates and break ARIA relationships.
       */
      setupAriaRelationships() {
        this.buttons.forEach((button, index) => {
          const blockId = button.dataset.blockId;
          const tabId = `FaqTab-${blockId}`;
          const panelId = `FaqPanel-${blockId}`;

          /* Set unique ID on the slider tab button */
          button.id = tabId;
          button.setAttribute('aria-controls', panelId);

          /* Find the matching content panel and set its ID */
          const matchingContent = this.contents.find((content) => content.dataset.blockId === blockId);

          if (matchingContent) {
            matchingContent.id = panelId;
            matchingContent.setAttribute('aria-labelledby', tabId);
          }
        });
      }

      setupEventListeners() {
        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('keydown', this.handleKeydown.bind(this));
      }

      handleClick(event) {
        const button = event.target.closest('._faq-category__tab-button');
        if (!button || !this.buttons.includes(button)) return;

        this.activateTab(button);
      }

      handleKeydown(event) {
        const button = event.target.closest('._faq-category__tab-button');
        if (!button || !this.buttons.includes(button)) return;

        const currentIndex = this.buttons.indexOf(button);
        let newIndex = currentIndex;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            event.preventDefault();
            newIndex = (currentIndex + 1) % this.buttons.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            event.preventDefault();
            newIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
            break;
          case 'Home':
            event.preventDefault();
            newIndex = 0;
            break;
          case 'End':
            event.preventDefault();
            newIndex = this.buttons.length - 1;
            break;
          case 'Enter':
          case ' ':
            event.preventDefault();
            this.activateTab(button);
            return;
          default:
            return;
        }

        this.buttons[newIndex].focus();
        this.activateTab(this.buttons[newIndex]);
      }

      activateTab(button) {
        const tabConnection = button.dataset.tabConnection;
        if (!tabConnection) return;

        /* Update visual states */
        this.buttons.forEach((btn) => btn.classList.remove('active'));
        this.contents.forEach((content) => content.classList.remove('active'));

        button.classList.add('active');

        /* Update ARIA states and tabindex for roving tabindex pattern */
        this.buttons.forEach((btn) => {
          const isActive = btn === button;
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
          btn.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        /* Show/hide panels and update active states */
        this.contents.forEach((content) => {
          const isActive = content.dataset.tabConnection === tabConnection;
          content.classList.toggle('active', isActive);
          if (isActive) {
            content.removeAttribute('hidden');
          } else {
            content.setAttribute('hidden', '');
          }
        });
      }
    }

    customElements.define('sb-faq', SbFaq);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sb-featured-collection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-featured-collection')) {
    class SbFeaturedCollection extends HTMLElement {
      constructor() {
        super();
        this.modal = this;
        this.toggleButtonHandlers = [];
        this.closeOtherModalsHandler = this.handleCloseOtherModals.bind(this);
      }
  
      connectedCallback() {
        try {
          this.initializeToggleButtons();
          this.initializeModalCloseListener();
        } catch (error) {
          console.error('[SbFeaturedCollection] Initialization error:', error);
        }
      }

      initializeToggleButtons() {
        // Find toggle button inside the modal
        const internalToggle = this.querySelector('._sb-featured-collection__modal-toggle');
        
        // Find toggle button outside the modal (sibling)
        const card = this.closest('._sb-featured-collection__card');
        const externalToggle = card ? card.querySelector(':scope > ._sb-featured-collection__modal-toggle') : null;

        // Store references to both buttons and their handlers
        const buttons = [internalToggle, externalToggle].filter(Boolean);
        
        buttons.forEach(button => {
          const handler = () => this.toggleModal();
          button.addEventListener('click', handler);
          this.toggleButtonHandlers.push({ button, handler });
        });
      }

      initializeModalCloseListener() {
        // Listen for events from other modals to close this one
        document.addEventListener('sb-featured-collection:open', this.closeOtherModalsHandler);
      }

      isTabletOrHigher() {
        return window.matchMedia('(min-width: 767px)').matches;
      }

      toggleModal() {
        const willBeActive = !this.modal.classList.contains('active');
        
        // On tablet and higher, handle scroll before opening
        if (this.isTabletOrHigher() && willBeActive) {
          // Emit scroll request event before opening
          document.dispatchEvent(new CustomEvent('sb-featured-collection:scroll-request', {
            detail: { source: this }
          }));
          
          // Wait for scroll animation to complete before toggling
          setTimeout(() => {
            this.completeToggle(willBeActive);
          }, 450);
        } else {
          // For closing or on mobile, toggle immediately
          this.completeToggle(willBeActive);
        }
      }

      completeToggle(willBeActive) {
        this.modal.classList.toggle('active');
        
        // Emit events on tablet and higher
        if (this.isTabletOrHigher()) {
          // Emit toggle event for slider dimension updates
          document.dispatchEvent(new CustomEvent('sb-featured-collection:toggle', {
            detail: { source: this, isOpening: willBeActive }
          }));
          
          // Emit open event when opening for closing other modals
          if (willBeActive) {
            document.dispatchEvent(new CustomEvent('sb-featured-collection:open', {
              detail: { source: this }
            }));
          }
        }
      }

      handleCloseOtherModals(event) {
        // Close this modal if it's not the one that was just opened
        if (event.detail.source !== this && this.modal.classList.contains('active')) {
          this.modal.classList.remove('active');
          
          // Emit toggle event when closed by another modal opening
          if (this.isTabletOrHigher()) {
            document.dispatchEvent(new CustomEvent('sb-featured-collection:toggle', {
              detail: { source: this, isOpening: false }
            }));
          }
        }
      }

      disconnectedCallback() {
        // Remove all event listeners
        this.toggleButtonHandlers.forEach(({ button, handler }) => {
          button.removeEventListener('click', handler);
        });
        this.toggleButtonHandlers = [];
        
        // Remove modal close listener
        document.removeEventListener('sb-featured-collection:open', this.closeOtherModalsHandler);
      }
    }
  
    customElements.define('sb-featured-collection', SbFeaturedCollection);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sb-featured-items-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-height-sync')) {
    /**
     * TdHeightSync Web Component
     * 
     * Synchronizes the height of the feature image with the swiper slides.
     * Listens for swiper initialization and window resize events to keep heights in sync.
     */
    class TdHeightSync extends HTMLElement {
      constructor() {
        super();
        this.featureImage = null;
        this.resizeTimeout = null;
        this.DESKTOP_BREAKPOINT = 1024;
        this.RESIZE_DEBOUNCE_MS = 150;
      }

      connectedCallback() {
        try {
          this.featureImage = this.querySelector('.td-featured-items__image');
          if (!this.featureImage) return;

          this.handleSwiperInit = this.handleSwiperInit.bind(this);
          this.handleResize = this.handleResize.bind(this);

          this.addEventListener('swiper:init', this.handleSwiperInit);
          window.addEventListener('resize', this.handleResize);
        } catch (error) {
          console.error('[TdHeightSync] Initialization error:', error);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('swiper:init', this.handleSwiperInit);
        window.removeEventListener('resize', this.handleResize);
        if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
        }
      }

      /**
       * Handles the swiper:init event to sync heights after swiper is ready
       */
      handleSwiperInit() {
        this.syncHeight();
      }

      /**
       * Handles window resize with debouncing for performance
       */
      handleResize() {
        if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(() => {
          this.syncHeight();
        }, this.RESIZE_DEBOUNCE_MS);
      }

      /**
       * Syncs the feature image height to match the swiper slide height.
       * Only applies on desktop where the feature image is visible.
       */
      syncHeight() {
        if (!this.featureImage) return;

        // Only sync on desktop - feature image is hidden on mobile via CSS
        if (window.innerWidth < this.DESKTOP_BREAKPOINT) {
          this.featureImage.style.height = '';
          return;
        }

        const slide = this.querySelector('.swiper-slide');
        if (!slide) return;

        const slideHeight = slide.offsetHeight;
        if (slideHeight > 0) {
          this.featureImage.style.height = `${slideHeight}px`;
        }
      }
    }

    customElements.define('td-height-sync', TdHeightSync);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sb-goal-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-goal-tabs')) {
    class SbGoalTabs extends HTMLElement {
      connectedCallback() {
        this.slidesWrapper = this.querySelector('._sb-goal-tabs__slides-wrapper');
        if (!this.slidesWrapper || !this.querySelector('video')) return;

        // Swiper toggles the active class, so mirror it onto video playback.
        this.observer = new MutationObserver(this.syncMedia);
        this.observer.observe(this.slidesWrapper, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
        });
        this.addEventListener('swiper:init', this.syncMedia);
        this.syncMedia();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('swiper:init', this.syncMedia);
      }

      syncMedia = () => {
        const slides = this.slidesWrapper.querySelectorAll('._sb-goal-tab__wrapper');
        const hasActive = this.slidesWrapper.querySelector('.swiper-slide-active');

        slides.forEach((slide, index) => {
          const video = slide.querySelector('video');
          if (!video) return;

          // Before Swiper boots, no slide carries the active class yet.
          const isActive = hasActive ? slide.classList.contains('swiper-slide-active') : index === 0;
          if (isActive) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      };
    }

    customElements.define('sb-goal-tabs', SbGoalTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_td-slider--metrics-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var ROOT_ATTR = '[data-metrics-gallery-slider-controls]';
    var MOBILE_MAX = 1023;
    var MOBILE_SLIDES = 1.25;

    function pad(value) {
      var text = String(value);
      return text.length < 2 ? '0' + text : text;
    }

    function slideTotal(root, slider) {
      var declared = Number(root.getAttribute('data-slide-count') || 0);
      if (declared > 0) return declared;
      if (slider && slider.slides) {
        return slider.slides.filter(function (slide) {
          return !slide.classList.contains('swiper-slide-duplicate');
        }).length;
      }
      return 0;
    }

    function bindFractionCounter(root, slider) {
      if (!root || root.dataset.metricsGalleryFractionBound === 'true') return;

      var currentEl = root.querySelector('[data-metrics-gallery-current]');
      var totalEl = root.querySelector('[data-metrics-gallery-total]');
      if (!currentEl || !totalEl || !slider) return;

      root.dataset.metricsGalleryFractionBound = 'true';

      var total = slideTotal(root, slider);
      var update = function () {
        var index = slider.realIndex || 0;
        if (total > 0) index = index % total;
        currentEl.textContent = pad(index + 1);
        totalEl.textContent = pad(total || index + 1);
      };

      update();
      slider.on('slideChange', update);
      slider.on('loopFix', update);
    }

    function isMobile() {
      return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
    }

    function applyMobilePeekToOptions(options) {
      if (!options || typeof options !== 'object') return options;
      options.slidesPerView = MOBILE_SLIDES;
      options.centeredSlides = false;
      options.slidesPerGroup = 1;
      options.breakpoints = options.breakpoints || {};
      Object.keys(options.breakpoints).forEach(function (bp) {
        if (parseInt(bp, 10) < 1024) {
          options.breakpoints[bp].slidesPerView = MOBILE_SLIDES;
          options.breakpoints[bp].centeredSlides = false;
          options.breakpoints[bp].slidesPerGroup = 1;
        }
      });
      return options;
    }

    function patchRootOptions(root) {
      if (!root) return;
      try {
        var parsed = JSON.parse(root.getAttribute('data-swiper-options') || '{}');
        root.setAttribute('data-swiper-options', JSON.stringify(applyMobilePeekToOptions(parsed)));
      } catch (e) {}
      if (root.sliderOptions) {
        root.sliderOptions = applyMobilePeekToOptions(root.sliderOptions);
      }
    }

    function applyMobilePeekToSlider(slider) {
      if (!slider || !slider.params || !isMobile()) return;
      slider.params.slidesPerView = MOBILE_SLIDES;
      slider.params.centeredSlides = false;
      slider.params.slidesPerGroup = 1;
      if (slider.params.breakpoints) {
        Object.keys(slider.params.breakpoints).forEach(function (bp) {
          if (parseInt(bp, 10) < 1024) {
            slider.params.breakpoints[bp].slidesPerView = MOBILE_SLIDES;
            slider.params.breakpoints[bp].centeredSlides = false;
            slider.params.breakpoints[bp].slidesPerGroup = 1;
          }
        });
      }
      slider.update();
    }

    function bindSlider(root) {
      if (!root) return;
      patchRootOptions(root);

      var slider = root.slider;
      if (!slider) return;

      applyMobilePeekToSlider(slider);
      bindFractionCounter(root, slider);
    }

    function bindAll() {
      document.querySelectorAll(ROOT_ATTR).forEach(function (root) {
        bindSlider(root);
      });
    }

    document.querySelectorAll(ROOT_ATTR).forEach(patchRootOptions);

    document.addEventListener('swiper:init', function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches(ROOT_ATTR)) return;
      bindSlider(target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindAll);
    } else {
      bindAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_td-video-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-video-card')) {
    class TdVideoCard extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('.td-video-card__frame');
        this.preview = this.querySelector('.td-video-card__preview');
        this.dialog = this.querySelector('.td-video-card__dialog');
        this.fullVideo = this.querySelector('.td-video-card__full');
        this.closeButton = this.querySelector('.td-video-card__close');
        if (!this.frame) return;

        // Hover preview only makes sense for real pointers.
        if (this.preview && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.frame.addEventListener('mouseenter', this.startPreview);
          this.frame.addEventListener('mouseleave', this.stopPreview);
        }

        this.frame.addEventListener('click', this.openDialog);
        this.closeButton?.addEventListener('click', this.closeDialog);
        this.dialog?.addEventListener('close', this.handleDialogClose);
        this.dialog?.addEventListener('click', this.handleBackdropClick);
      }

      disconnectedCallback() {
        this.stopPreview();
        if (this.dialog?.open) this.dialog.close();
      }

      startPreview = () => {
        if (!this.preview || this.dialog?.open) return;
        this.preview.currentTime = 0;
        this.preview.play().catch(() => {});
      };

      stopPreview = () => {
        if (!this.preview) return;
        this.preview.pause();
        this.preview.currentTime = 0;
      };

      openDialog = (event) => {
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        event?.preventDefault();
        this.stopPreview();

        // ::backdrop only inherits from the dialog itself, so copy the value down.
        const overlay = getComputedStyle(this).getPropertyValue('--td-video-overlay').trim();
        if (overlay) this.dialog.style.setProperty('--td-video-overlay', overlay);

        this.dialog.showModal();
        document.documentElement.setAttribute('scroll-lock', '');

        if (this.fullVideo) {
          this.fullVideo.currentTime = 0;
          this.fullVideo.play().catch(() => {});
        }
      };

      closeDialog = () => {
        if (this.dialog?.open) this.dialog.close();
      };

      handleDialogClose = () => {
        if (this.fullVideo) {
          this.fullVideo.pause();
          this.fullVideo.currentTime = 0;
        }
        document.documentElement.removeAttribute('scroll-lock');
      };

      handleBackdropClick = (event) => {
        if (event.target === this.dialog) this.closeDialog();
      };
    }

    customElements.define('td-video-card', TdVideoCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bf-eb-review"] && !Shopify.designMode) return;
  try {
    (() => {
    function scrollToReviews(event) {
      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
      const trigger = event.target.closest?.('[data-scroll-to-reviews="true"]');
      const target = trigger && document.querySelector('#judgeme_product_reviews');
      if (!target) return;
      event.preventDefault();
      const header = document.querySelector('header-component, header, .section-header');
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - (header?.offsetHeight || 0),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
    document.addEventListener('click', scrollToReviews);
    document.addEventListener('keydown', scrollToReviews);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.__tdBuyButtonsCheckoutRedirect) {
    window.__tdBuyButtonsCheckoutRedirect = true;

    const decodeDiscount = (b64) => {
      if (!b64) return '';
      try {
        return decodeURIComponent(escape(atob(b64)));
      } catch (e) {
        return '';
      }
    };

    const buildCheckoutUrl = (variantId, quantity, discountCode) => {
      let root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      root = root.replace(/\/$/, '');
      let url = `${root}/cart/${variantId}:${quantity}`;
      if (discountCode) {
        url += `?discount=${encodeURIComponent(discountCode)}`;
      }
      return url;
    };

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const host = form.closest('product-form-component[data-redirect-checkout="true"]');
        if (!host) return;

        const addButton = host.querySelector('[ref="addToCartButton"]');
        if (addButton && addButton.getAttribute('disabled') === 'true') return;

        event.preventDefault();
        event.stopPropagation();

        const variantInput = form.querySelector('[name="id"]');
        const variantId = variantInput && variantInput.value;
        if (!variantId) return;

        const quantityInput = form.querySelector('[name="quantity"]');
        const quantityValue = quantityInput && quantityInput.value
          ? quantityInput.value
          : host.dataset.quantityDefault;
        const quantity = Math.max(1, parseInt(quantityValue, 10) || 1);

        const section = host.closest('.shopify-section');
        const toggle = section ? section.querySelector('td-pdp-offer-toggle') : null;
        const discountCode =
          toggle && toggle.classList.contains('is-active') ? decodeDiscount(toggle.dataset.dc) : '';

        if (addButton) {
          addButton.classList.add('is-loading');
          addButton.setAttribute('disabled', 'true');
        }

        window.location.href = buildCheckoutUrl(variantId, quantity, discountCode);
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["page-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const trigger = event.target.closest('.open_faq, .open_faq_3');

    if (trigger) {
      const faqIcon = trigger.querySelector(".faq_icon");
      if (faqIcon) {
          faqIcon.classList.toggle("faq_icon_open");
      }
      const contentPanel = trigger.nextElementSibling;
      
      if (contentPanel) {
          contentPanel.classList.toggle("swiper-slide-open");
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    (function() {
    const ratingWrappers = document.querySelectorAll('[data-scroll-to-reviews="true"]');
    if (ratingWrappers.length === 0) return;

    const scrollToReviews = (e) => {
      if (e.type === 'keydown' && !['Enter', ' '].includes(e.key)) return;
      e.preventDefault();

      const target = document.querySelector('#judgeme_product_reviews');
      if (!target) return;

      const header = document.querySelector('header-component, header, .section-header');
      const offset = header?.offsetHeight || 0;
      const topPosition = target.getBoundingClientRect().top + window.scrollY - offset;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: topPosition,
        behavior: reduceMotion ? 'instant' : 'smooth'
      });

      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    };

    ratingWrappers.forEach((ratingWrapper) => {
      ratingWrapper.addEventListener('click', scrollToReviews);
      ratingWrapper.addEventListener('keydown', scrollToReviews);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["td-coupon-image-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-coupon-image-box')) {
    const VISIBLE_MS = 1800;
    const DEBOUNCE_MS = 600;
    let popupEl = null;
    let hideTimer = null;
    let lastClickAt = 0;
    let inFlight = false;

    function ensurePopup() {
      if (popupEl && document.body.contains(popupEl)) return popupEl;
      popupEl = document.createElement('div');
      popupEl.className = 'td-coupon-image-box__global-popup';
      popupEl.setAttribute('role', 'status');
      popupEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(popupEl);
      return popupEl;
    }

    function showPopup(label, bg, color) {
      const el = ensurePopup();
      el.textContent = label;
      if (bg) el.style.setProperty('--td-coupon-popup-bg', bg);
      if (color) el.style.setProperty('--td-coupon-popup-color', color);
      // Re-trigger transition if popup is already visible
      if (el.classList.contains('is-visible')) {
        el.classList.remove('is-visible');
        void el.offsetWidth;
      }
      el.classList.add('is-visible');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => el.classList.remove('is-visible'), VISIBLE_MS);
    }

    class TdCouponImageBox extends HTMLElement {
      connectedCallback() {
        const trigger = this.querySelector('.td-coupon-image-box__trigger');
        if (!trigger) return;
        if (!this.dataset.code) return;
        if (trigger.tagName.toLowerCase() !== 'button') return;

        this._onClick = this._onClick.bind(this);
        trigger.addEventListener('click', this._onClick);
      }

      _onClick(event) {
        event.preventDefault();
        const now = Date.now();
        if (inFlight) return;
        if (now - lastClickAt < DEBOUNCE_MS) return;
        lastClickAt = now;
        this.copyCode();
      }

      copyCode() {
        const code = this.dataset.code;
        if (!code) return;
        inFlight = true;
        const done = () => { inFlight = false; };

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code)
            .then(() => { this._feedback(); })
            .catch(() => { this._fallbackCopy(code); })
            .finally(done);
        } else {
          try { this._fallbackCopy(code); } finally { done(); }
        }
      }

      _fallbackCopy(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        textArea.style.top = '-9999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          this._feedback();
        } catch (err) {
          console.error('td-coupon-image-box: copy failed', err);
        }
        document.body.removeChild(textArea);
      }

      _feedback() {
        const label = this.dataset.copiedLabel || 'Copied!';
        const styles = getComputedStyle(this);
        const bg = styles.getPropertyValue('--td-coupon-popup-bg').trim();
        const color = styles.getPropertyValue('--td-coupon-popup-color').trim();
        showPopup(label, bg, color);
      }
    }
    customElements.define('td-coupon-image-box', TdCouponImageBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["td-delivery-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-delivery-note')) {
    class TdDeliveryNote extends HTMLElement {
      connectedCallback() {
        const dateEl = this.querySelector('[ref="deliveryDate"]');
        if (!dateEl) return;

        const days = Math.max(0, parseInt(this.dataset.deliveryDays || '3', 10) || 0);
        const deliveryDate = new Date();
        deliveryDate.setDate(deliveryDate.getDate() + days);
        dateEl.dateTime = deliveryDate.toISOString().slice(0, 10);
        dateEl.textContent = new Intl.DateTimeFormat('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
        }).format(deliveryDate);
      }
    }

    customElements.define('td-delivery-note', TdDeliveryNote);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["td-discount-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-discount-code')) {
  class TdDiscountCode extends HTMLElement {
    constructor() {
      super();
      this.copiedStateDuration = 2000;
    }

    connectedCallback() {
      const containers = this.querySelectorAll('.td-discount-code__container');
      
      if (!containers.length) {
        return;
      }
      
      containers.forEach((container) => {
        container.addEventListener('click', this.copyDiscountCode.bind(this));
      });
    }
    
    copyDiscountCode(event) {
      const container = event.currentTarget;
      const promoCode = container.getAttribute('data-code');
      
      if (!promoCode) {
        return;
      }
      
      // Use the modern Clipboard API if available
      if (navigator.clipboard) {
        navigator.clipboard.writeText(promoCode).then(() => {
          this.showCopyFeedback(container);
        }).catch((err) => {
          // Fallback for clipboard API failure
          this.fallbackCopyTextToClipboard(promoCode, container);
        });
      } else {
        // Fallback for older browsers
        this.fallbackCopyTextToClipboard(promoCode, container);
      }
    }
    
    fallbackCopyTextToClipboard(text, container) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
        this.showCopyFeedback(container);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
      
      document.body.removeChild(textArea);
    }
    
    showCopyFeedback(container) {
      // Show "Copied!" in container
      container.classList.add('copied');
      setTimeout(() => {
        container.classList.remove('copied');
      }, this.copiedStateDuration);
    }
  }
  customElements.define('td-discount-code', TdDiscountCode);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["td-offer-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-offer-price')) {
    const OFFER_EVENT = 'td:pdp-offer-change';

    const parseCents = (value) => Math.max(0, Math.round(Number(value) || 0));

    const moneyFormatFromText = (value) => {
      const text = String(value || '').trim();
      const numberMatch = text.match(/[0-9][0-9.,\s]*/);
      const numberText = numberMatch ? numberMatch[0].trim() : '';

      return {
        prefix: numberMatch ? text.slice(0, numberMatch.index) : '',
        suffix: numberMatch ? text.slice(numberMatch.index + numberMatch[0].length) : '',
        decimalSeparator: numberText.includes(',') && !numberText.includes('.') ? ',' : '.',
      };
    };

    const formatMoneyFromCents = (cents, format) => {
      const amount = Math.round(cents) / 100;
      const decimalSeparator = format?.decimalSeparator || '.';
      const money = amount.toFixed(2).replace('.', decimalSeparator);
      return `${format?.prefix || ''}${money}${format?.suffix || ''}`;
    };

    const installmentPerPaymentCents = (priceCents, count) => {
      const periods = parseInt(String(count), 10);
      if (!periods || periods < 1 || !priceCents) return 0;
      return Math.round(priceCents / periods);
    };

    const discountedCents = (priceCents, percentage) => {
      const discount = Math.min(100, Math.max(1, Number(percentage) || 25));
      return Math.round(priceCents * (1 - discount / 100));
    };

    const offerPriceCents = (priceCents, discountType, percentage, saveAmountCents) => {
      if (discountType === 'fixed_amount') {
        return Math.max(0, priceCents - parseCents(saveAmountCents));
      }

      return discountedCents(priceCents, percentage);
    };

    class TdOfferPrice extends HTMLElement {
      connectedCallback() {
        this.installmentAmount = this.querySelector('[ref="installmentAmount"]');
        this.installmentCountEl = this.querySelector('[ref="installmentCount"]');
        this.installmentsEl = this.querySelector('[ref="installments"]');
        this.section = this.closest('.shopify-section, dialog');
        this.productDetails = this.closest('.product-details');
        this.offerPriceEl = this.querySelector('.td-offer-price__final--offer');

        if (this.productDetails) {
          this.productDetails.addEventListener(OFFER_EVENT, this.handleOfferChange);
        }
        if (this.section) {
          this.section.addEventListener(OFFER_EVENT, this.handleOfferChange);
          this.section.addEventListener('variant:update', this.handleVariantUpdate);
        }

        this.syncFromToggle();
        requestAnimationFrame(() => this.syncFromToggle());
      }

      disconnectedCallback() {
        if (this.productDetails) {
          this.productDetails.removeEventListener(OFFER_EVENT, this.handleOfferChange);
        }
        if (this.section) {
          this.section.removeEventListener(OFFER_EVENT, this.handleOfferChange);
          this.section.removeEventListener('variant:update', this.handleVariantUpdate);
        }
      }

      syncFromToggle = () => {
        const toggle = this.section?.querySelector('td-pdp-offer-toggle');
        const active = Boolean(toggle?.classList.contains('is-active'));
        this.applyState({ active });
      };

      handleOfferChange = (event) => {
        const detail = event.detail || {};
        this.applyState(detail);
      };

      applyState = (detail) => {
        const active = Boolean(detail.active);
        this.classList.toggle('is-offer-active', active);

        const showInstallment = this.dataset.showInstallment === 'true';
        if (this.installmentsEl) {
          this.installmentsEl.hidden = !showInstallment;
        }

        const basePriceText = this.dataset.basePrice || '';
        const baseCents = parseCents(this.dataset.basePriceCents);
        const offerCents = offerPriceCents(
          baseCents,
          this.dataset.discountType,
          this.dataset.discountPercentage,
          this.dataset.saveAmountCents
        );
        const moneyFormat = moneyFormatFromText(basePriceText);
        if (this.offerPriceEl) {
          this.offerPriceEl.textContent = formatMoneyFromCents(offerCents, moneyFormat);
        }

        if (!showInstallment) return;

        const count = parseInt(this.dataset.installmentCount, 10) || 4;
        if (this.installmentCountEl) {
          this.installmentCountEl.textContent = String(count);
        }

        if (this.installmentAmount) {
          const activeCents = active ? offerCents : baseCents;
          const perPaymentCents = installmentPerPaymentCents(activeCents, count);
          this.installmentAmount.textContent = formatMoneyFromCents(perPaymentCents, moneyFormat);
        }
      };

      handleVariantUpdate = (event) => {
        const detail = event.detail || {};
        const productId = detail.data && detail.data.productId;
        if (productId && this.dataset.productId && productId !== this.dataset.productId) return;

        const html = detail.data && detail.data.html;
        if (!html) return;

        const newHost = html.querySelector(`.td-offer-price--${this.blockId}`);
        if (!newHost) return;

        [
          'data-variant-price-cents',
          'data-regular-price',
          'data-base-price',
          'data-base-price-cents',
          'data-discount-type',
          'data-discount-percentage',
          'data-save-amount-cents',
          'data-installment-count',
          'data-show-installment',
        ].forEach((attr) => {
          const val = newHost.getAttribute(attr);
          if (val !== null) this.setAttribute(attr, val);
        });

        const replaceText = (selector, source) => {
          const current = this.querySelector(selector);
          const next = source?.querySelector(selector);
          if (current && next) current.textContent = next.textContent;
        };

        replaceText('.td-offer-price__row--default .td-offer-price__final', newHost);
        replaceText('.td-offer-price__compare', newHost);
        replaceText('[ref="badge"]', newHost);
        replaceText('[ref="installmentCount"]', newHost);

        this.syncFromToggle();
      };

      get blockId() {
        const match = (this.className || '').match(/td-offer-price--([0-9a-zA-Z_-]+)/);
        return match ? match[1] : '';
      }
    }

    customElements.define('td-offer-price', TdOfferPrice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["td-pdp-detail-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-pdp-detail-tabs')) {
    class TdPdpDetailTabs extends HTMLElement {
      connectedCallback() {
        this.tablist = this.querySelector('[ref="tablist"]');
        this.panelsHost = this.querySelector('[ref="panels"]');
        if (!this.tablist || !this.panelsHost) return;

        this.panels = [...this.panelsHost.querySelectorAll(':scope > .td-pdp-detail-tab-panel')];
        if (!this.panels.length) return;

        this.buildTabs();
        this.activateTab(0);

        // Theme editor: reveal the panel that owns the block a merchant just selected.
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      buildTabs = () => {
        this.tablist.innerHTML = '';
        this.tabs = this.panels.map((panel, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'td-pdp-detail-tabs__tab';
          button.textContent = panel.dataset.tabLabel || `Tab ${index + 1}`;
          button.id = `td-pdp-tab-${this.blockId}-${index}`;
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-selected', 'false');
          button.addEventListener('click', () => this.activateTab(index));

          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', button.id);

          this.tablist.appendChild(button);
          return button;
        });
      };

      activateTab = (index) => {
        this.panels.forEach((panel, i) => {
          const active = i === index;
          panel.hidden = !active;
          this.tabs[i]?.setAttribute('aria-selected', String(active));
        });
        this.activeIndex = index;
      };

      handleBlockSelect = (event) => {
        const target = event.target;
        if (!target || !this.contains(target)) return;

        const panel = target.closest('.td-pdp-detail-tab-panel');
        const index = this.panels.indexOf(panel);
        if (index > -1) this.activateTab(index);
      };

      get blockId() {
        const match = (this.className || '').match(/td-pdp-detail-tabs--([0-9a-zA-Z_-]+)/);
        return match ? match[1] : 'tabs';
      }
    }

    customElements.define('td-pdp-detail-tabs', TdPdpDetailTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["td-pdp-offer-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-pdp-offer-toggle')) {
    const OFFER_EVENT = 'td:pdp-offer-change';

    const decode = (b64) => {
      if (!b64) return '';
      try {
        return decodeURIComponent(escape(atob(b64)));
      } catch (e) {
        return '';
      }
    };

    class TdPdpOfferToggle extends HTMLElement {
      connectedCallback() {
        this.toggleBtn = this.querySelector('[ref="toggle"]');
        this.subtitleOff = this.querySelector('.td-pdp-offer-toggle__subtitle--off');
        this.subtitleOn = this.querySelector('.td-pdp-offer-toggle__subtitle--on');
        this.section = this.closest('.shopify-section, dialog');
        this.active = this.dataset.defaultOn === 'true';

        if (this.toggleBtn) {
          this.toggleBtn.addEventListener('click', this.handleToggle);
        }

        if (this.section) {
          this.section.addEventListener('variant:update', this.handleVariantUpdate);
        }

        document.addEventListener('cart:update', this.handleCartUpdate);

        this.syncSubtitle();
        this.dispatchOfferChange();
        requestAnimationFrame(() => this.dispatchOfferChange());
      }

      disconnectedCallback() {
        if (this.section) {
          this.section.removeEventListener('variant:update', this.handleVariantUpdate);
        }
        document.removeEventListener('cart:update', this.handleCartUpdate);
      }

      getOfferPriceTexts = () => {
        const offerPrice = this.section?.querySelector('td-offer-price');
        if (!offerPrice) {
          return {
            baseMoney: '',
            offerMoney: '',
          };
        }

        return {
          baseMoney: offerPrice.dataset.basePrice || '',
          offerMoney: this.calculateOfferPrice(
            offerPrice.dataset.basePrice || '',
            offerPrice.dataset.basePriceCents || '',
            offerPrice.dataset.discountPercentage || '25',
            offerPrice.dataset.discountType || 'percentage',
            offerPrice.dataset.saveAmountCents || ''
          ),
        };
      };

      calculateOfferPrice = (
        priceText,
        priceCentsText,
        discountText,
        discountType = 'percentage',
        saveAmountCentsText = ''
      ) => {
        const priceCents = Math.max(0, Math.round(Number(priceCentsText) || 0));
        if (!priceCents) return '';

        const text = String(priceText || '').trim();
        const numberMatch = text.match(/[0-9][0-9.,\s]*/);
        const numberText = numberMatch ? numberMatch[0].trim() : '';
        const format = {
          prefix: numberMatch ? text.slice(0, numberMatch.index) : '',
          suffix: numberMatch ? text.slice(numberMatch.index + numberMatch[0].length) : '',
          decimalSeparator: numberText.includes(',') && !numberText.includes('.') ? ',' : '.',
        };
        let offerCents = priceCents;

        if (discountType === 'fixed_amount') {
          offerCents = priceCents - Math.max(0, Math.round(Number(saveAmountCentsText) || 0));
        } else {
          const discount = Math.min(100, Math.max(1, Number(discountText) || 25));
          offerCents = Math.round(priceCents * (1 - discount / 100));
        }

        const amount = Math.max(0, offerCents) / 100;
        const money = amount.toFixed(2).replace('.', format.decimalSeparator);
        return `${format.prefix}${money}${format.suffix}`;
      };

      handleToggle = () => {
        this.active = !this.active;
        this.classList.toggle('is-active', this.active);
        if (this.toggleBtn) {
          this.toggleBtn.setAttribute('aria-pressed', String(this.active));
        }
        this.syncSubtitle();
        this.dispatchOfferChange();
      };

      syncSubtitle = () => {
        if (!this.subtitleOn || !this.subtitleOff) return;
        if (this.active) {
          this.subtitleOff.hidden = true;
          this.subtitleOn.hidden = false;
        } else {
          this.subtitleOff.hidden = false;
          this.subtitleOn.hidden = true;
        }
      };

      getPayload = () => {
        const texts = this.getOfferPriceTexts();
        const code = decode(this.dataset.dc);

        return {
          active: this.active,
          code,
          baseMoney: texts.baseMoney,
          offerMoney: texts.offerMoney,
          atcLabel: this.dataset.atcLabel || 'Add to Cart',
        };
      };

      dispatchOfferChange = () => {
        const payload = this.getPayload();
        const event = new CustomEvent(OFFER_EVENT, {
          bubbles: true,
          detail: payload,
        });
        this.dispatchEvent(event);
        this.updateAtcButton(payload);
      };

      updateAtcButton = (payload) => {
        const section = this.closest('.shopify-section');
        if (!section) return;

        const atcContent = section.querySelector('.buy-buttons-block .add-to-cart-text__content');
        if (!atcContent) return;

        const price = payload.active ? payload.offerMoney : payload.baseMoney;
        if (price) {
          atcContent.textContent = `${payload.atcLabel} — ${price}`;
        } else {
          atcContent.textContent = payload.atcLabel;
        }
      };

      handleVariantUpdate = (event) => {
        const detail = event.detail || {};
        const productId = detail.data && detail.data.productId;
        if (productId && this.dataset.productId && productId !== this.dataset.productId) return;

        const resource = detail.resource;
        if (resource && resource.id) {
          this.dataset.variantId = String(resource.id);
        }

        const html = detail.data && detail.data.html;
        if (!html) return;

        const newHost = html.querySelector(`.td-pdp-offer-toggle--${this.blockId}`);
        if (!newHost) return;

        const dc = newHost.getAttribute('data-dc');
        if (dc !== null) this.setAttribute('data-dc', dc);

        const newSubtitleOn = newHost.querySelector('.td-pdp-offer-toggle__subtitle--on');
        if (newSubtitleOn && this.subtitleOn) {
          this.subtitleOn.textContent = newSubtitleOn.textContent;
        }

        this.dispatchOfferChange();
      };

      handleCartUpdate = async (event) => {
        const detail = event.detail || {};
        const data = detail.data || {};

        if (data.didError || data.source !== 'product-form-component') return;
        if (data.productId && this.dataset.productId && data.productId !== this.dataset.productId) return;
        if (!this.active) return;

        const code = decode(this.dataset.dc);
        if (!code) return;

        const section = this.closest('.shopify-section');
        const eventTarget = event.target;
        if (!section || !eventTarget || !(eventTarget instanceof Node) || !section.contains(eventTarget)) return;

        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const existing = (cart.discount_codes || []).map((d) => d.code).filter(Boolean);
          if (existing.includes(code)) return;

          const sections = [];
          document.querySelectorAll('cart-items-component').forEach((el) => {
            if (el instanceof HTMLElement && el.dataset.sectionId) {
              sections.push(el.dataset.sectionId);
            }
          });

          const updateRes = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              discount: [...existing, code].join(','),
              sections,
            }),
          });

          const updateData = await updateRes.json();

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: updateData,
                sourceId: this.id || '',
                data: {
                  source: 'td-pdp-offer-toggle',
                  sections: updateData.sections,
                },
              },
            })
          );
        } catch (e) {
          console.error(e);
        }
      };

      get blockId() {
        const match = (this.className || '').match(/td-pdp-offer-toggle--([0-9a-zA-Z_-]+)/);
        return match ? match[1] : '';
      }
    }

    customElements.define('td-pdp-offer-toggle', TdPdpOfferToggle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["td-video-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-video-grid')) {
    const DRAG_THRESHOLD = 5;

    class TdVideoGrid extends HTMLElement {
      connectedCallback() {
        this.dragDistance = 0;

        // Touch devices already swipe natively; only mice need drag-to-scroll.
        this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.addEventListener('pointerdown', this.handlePointerDown);
        this.addEventListener('click', this.suppressClickAfterDrag, true);

        this.resizeObserver = new ResizeObserver(this.syncScrollableState);
        this.resizeObserver.observe(this);
        this.syncScrollableState();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.stopDrag();
      }

      get overflows() {
        return this.scrollWidth - this.clientWidth > 1;
      }

      syncScrollableState = () => {
        if (this.overflows && this.finePointer?.matches) {
          this.setAttribute('data-scrollable', '');
        } else {
          this.removeAttribute('data-scrollable');
        }
      };

      handlePointerDown = (event) => {
        if (event.button !== 0 || !this.finePointer?.matches || !this.overflows) return;

        this.pointerId = event.pointerId;
        this.dragStartX = event.clientX;
        this.dragStartScroll = this.scrollLeft;
        this.dragDistance = 0;

        this.addEventListener('pointermove', this.handlePointerMove);
        this.addEventListener('pointerup', this.stopDrag);
        this.addEventListener('pointercancel', this.stopDrag);
      };

      handlePointerMove = (event) => {
        if (event.pointerId !== this.pointerId) return;

        const delta = event.clientX - this.dragStartX;
        if (Math.abs(delta) < DRAG_THRESHOLD && !this.dragDistance) return;

        this.dragDistance = Math.abs(delta);
        this.setAttribute('data-dragging', '');
        // Capture keeps move events coming even when the cursor leaves a card.
        if (!this.hasPointerCapture(event.pointerId)) this.setPointerCapture(event.pointerId);
        this.scrollLeft = this.dragStartScroll - delta;
      };

      stopDrag = (event) => {
        this.removeEventListener('pointermove', this.handlePointerMove);
        this.removeEventListener('pointerup', this.stopDrag);
        this.removeEventListener('pointercancel', this.stopDrag);
        this.removeAttribute('data-dragging');

        const pointerId = event?.pointerId ?? this.pointerId;
        if (pointerId != null && this.hasPointerCapture(pointerId)) this.releasePointerCapture(pointerId);
        this.pointerId = null;

        // Cleared after the click event that follows pointerup has been handled.
        setTimeout(() => {
          this.dragDistance = 0;
        }, 0);
      };

      suppressClickAfterDrag = (event) => {
        if (this.dragDistance < DRAG_THRESHOLD) return;
        event.preventDefault();
        event.stopPropagation();
        this.dragDistance = 0;
      };
    }

    customElements.define('td-video-grid', TdVideoGrid);
  }
  } catch(e) { console.error(e); }
})();

})();
